import { useCallback, useEffect, useState } from "react";
import { Search, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import api, { formatIDR } from "@/lib/api";
import { SettlementDetail } from "@/components/SettlementDetail";

const STATUS_CLS = { SUCCESS: "bg-emerald-50 text-emerald-700", FAILED: "bg-red-50 text-red-700" };

export const AdminSettlements = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [detailId, setDetailId] = useState(null);
  const closeDetail = useCallback(() => setDetailId(null), []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/withdrawals", { params: { q } });
      setItems(data);
    } catch {
      toast.error("Gagal memuat data settlement");
    } finally {
      setLoading(false);
    }
  }, [q]);

  useEffect(() => { const t = setTimeout(load, 350); return () => clearTimeout(t); }, [load]);

  return (
    <div className="space-y-4" data-testid="admin-settlements">
      <div className="relative max-w-md">
        <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input data-testid="admin-settlement-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari seller, no. HP, atau no. penarikan..." className="w-full pl-9 pr-3 py-2.5 rounded-xl border border-gray-200 text-sm outline-none bg-white" />
      </div>
      {loading && items.length === 0 ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#0B4DA2]" /></div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-gray-400 text-sm" data-testid="admin-settlement-empty">Belum ada penarikan saldo.</div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 text-left">
              <tr><th className="p-3">No. Penarikan</th><th className="p-3">Seller</th><th className="p-3">Rekening</th><th className="p-3">Produk</th><th className="p-3">Nominal</th><th className="p-3">Status</th><th className="p-3"></th></tr>
            </thead>
            <tbody>
              {items.map((w) => (
                <tr key={w.id} data-testid={`admin-settlement-row-${w.id}`} className="border-t border-gray-100">
                  <td className="p-3"><div className="font-mono text-xs">{w.mch_order_no}</div><div className="text-[11px] text-gray-400">{new Date(w.created_at).toLocaleString("id-ID")}</div></td>
                  <td className="p-3"><div className="font-medium">{w.seller_name}</div><div className="text-[11px] text-gray-400">{w.seller_phone}</div></td>
                  <td className="p-3 text-xs">{w.bank_name || "-"} {w.account_no || ""}</td>
                  <td className="p-3 text-xs">{w.order_count} produk</td>
                  <td className="p-3 font-bold">{formatIDR(w.amount)}</td>
                  <td className="p-3"><span className={`text-[11px] px-2 py-1 rounded-full font-semibold ${STATUS_CLS[w.status] || "bg-amber-50 text-amber-700"}`}>{w.status || "-"}</span></td>
                  <td className="p-3"><button data-testid={`admin-settlement-view-${w.id}`} onClick={() => setDetailId(w.id)} className="flex items-center gap-1 text-xs font-semibold text-[#0B4DA2] hover:underline"><FileText className="w-3.5 h-3.5" /> Rincian</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <SettlementDetail withdrawalId={detailId} onClose={closeDetail} />
    </div>
  );
};
